import type { Session } from "../state/types";

/**
 * Froeet: oekten appen starter i foer noen har logget inn.
 *
 * MIDLERTIDIG, OG SKAL BARE LESES AV state/session.ts. Oppsettet gjoeres med
 * SQL og seed i fase 0, ikke med et grensesnitt, og innloggingen er bevisst
 * utsatt saa flatene kan proeves uten aa logge inn hver gang.
 *
 * Naar `production` og `production_member` finnes i Supabase, hentes verdiene
 * derfra og denne fila slettes. Resten av appen leser oekten gjennom
 * `useSession()` og merker ikke byttet.
 */
export const FROE: Session = {
  production: {
    id: "00000000-0000-4000-8000-000000000001",
    name: "Øya",
    framerate: "25",
    dropFrame: false,
    endDateIso: "2026-12-19",
    nle: null,
    units: ["LET 1", "LET 2", "LET 3", "Kontrollrom A"],
  },
  member: {
    id: "00000000-0000-4000-8000-000000000002",
    displayName: "Kari Nordmann",
    initials: "KN",
    role: "regi",
  },
  shootDay: "7",
  unitName: "LET 2",
  unitId: "",
};

/** Id-en «privat» har. Fast verdi, ikke NULL — se Production i types.ts. */
export const PRIVAT_ID = "privat";

/**
 * Arbeid utenfor en produksjon.
 *
 * Feltappen skal kunne brukes av hvem som helst uten innlogging: en VJ, en
 * liten produksjon, eller noen som bare vil ha tidskodet logg paa en egen
 * jobb. Da finnes det ingen produksjon aa knytte loggen til, og «privat» er
 * stedet den ligger.
 *
 * `endDateIso` er null, og det er det ENESTE stedet i appen det er lov.
 * Ingen automatisk sletting: det er brukerens egen logg, og ingen
 * produksjons sluttdato gjelder for den.
 *
 * Ikke MIDLERTIDIG, i motsetning til FROE over. Privat blir staaende naar
 * innloggingen kommer.
 */
export const PRIVAT: Session = {
  production: {
    id: PRIVAT_ID,
    name: "Privat",
    framerate: "25",
    dropFrame: false,
    endDateIso: null,
    nle: null,
    units: [],
  },
  member: {
    id: PRIVAT_ID,
    displayName: "Privat",
    // Ingen initialer: ingen andre leser denne loggen, saa det er ingenting
    // aa skille fra. Initialer finnes for aa vite hvem som skrev hva.
    initials: "",
    role: "regi",
  },
  shootDay: "1",
  unitName: "",
  unitId: "",
};
